import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-res-k8s-ingress",
  "use": "oc-res-k8s-ingress-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-res-k8s-ingress\"><path d=\"M430.293 664.96l60.374 60.373L704 512 490.667 298.667l-60.374 60.373 110.294 110.293H128v85.334h412.587L430.293 664.96zM810.667 128H213.333C166.187 128 128 166.187 128 213.333V384h85.333V213.333h597.334v597.334H213.333V640H128v170.667C128 857.813 166.187 896 213.333 896h597.334C857.813 896 896 857.813 896 810.667V213.333C896 166.187 857.813 128 810.667 128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol